"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextPicturePairs = exports.mapSynonymToExerciseParams = void 0;
function mapSynonymToExerciseParams(response) {
    var _a, _b, _c;
    if (!response)
        return response;
    return {
        id: String(response.id),
        slug: response.slug,
        number: response.number,
        text: {
            title: (_b = (_a = response.text) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : '',
            text_type: response.text.text_type,
            offers: ((_c = response.data) !== null && _c !== void 0 ? _c : []).map((item, index) => {
                var _a, _b, _c, _d, _e, _f;
                return ({
                    id: (_a = item.id) !== null && _a !== void 0 ? _a : index,
                    order: index,
                    right_word: item.answer,
                    full_question_audio: (_b = (item.audio || item.full_question_audio)) !== null && _b !== void 0 ? _b : null,
                    right_audio: (_c = item.right_audio) !== null && _c !== void 0 ? _c : '',
                    content: item.question,
                    hint: (_d = item.hint) !== null && _d !== void 0 ? _d : '',
                    additional_correct_words: (_e = item.additional_correct_words) !== null && _e !== void 0 ? _e : [],
                    additional_words: (_f = item.additional_words) !== null && _f !== void 0 ? _f : [],
                });
            }),
        },
    };
}
exports.mapSynonymToExerciseParams = mapSynonymToExerciseParams;
function getTextPicturePairs(response) {
    var _a, _b, _c;
    // старый формат
    if ((_b = (_a = response.text) === null || _a === void 0 ? void 0 : _a.offers) === null || _b === void 0 ? void 0 : _b.length) {
        return response.text.offers.map((offer) => ({
            group: offer.order,
            items: [offer]
        }));
    }
    // новый формат
    if ((_c = response.form) === null || _c === void 0 ? void 0 : _c.length) {
        const groups = {};
        response.form.forEach((item) => {
            if (!groups[item.group]) {
                groups[item.group] = [];
            }
            groups[item.group].push(item);
        });
        return Object.entries(groups)
            .sort(([a], [b]) => Number(a) - Number(b))
            .map(([group, items]) => ({
            group: Number(group),
            items: items.sort((a, b) => a.order - b.order)
        }));
    }
    return [];
}
exports.getTextPicturePairs = getTextPicturePairs;
